import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid, FGridMoneyCell, FGridPercentCell, FGridStatusChip } from '../grid';
import { StatusSummary } from './activityprogramme.models';

export default class ProgrammeStatusGrid extends React.PureComponent<{ rows: StatusSummary[]; loading?: boolean }> {
  private columns: GridColDef[] = [
    { field: 'statusname', headerName: 'Status', width: 180, renderCell: FGridStatusChip },
    { field: 'activities', headerName: 'Activities', width: 120, type: 'number' },
    { field: 'plannedamount', headerName: 'Planned Amount', width: 160, renderCell: FGridMoneyCell },
    { field: 'revisedamount', headerName: 'Revised Amount', width: 160, renderCell: FGridMoneyCell },
    { field: 'share', headerName: 'Share', width: 110, renderCell: FGridPercentCell },
  ];

  render() {
    return (
      <FDataGrid
        title="Programme Summary by Status"
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={360}
        getRowId={(row: StatusSummary) => row.id}
        showQuickFilter
        pageSizeOptions={[10, 20, 50]}
      />
    );
  }
}
